// extracted by mini-css-extract-plugin
export var link = "k_bg";
export var iconBubble = "k_bh";
export var blockTitle = "k_bj";
export var iconList = "k_bk";
export var item = "k_bl";
export var itemName = "k_bm";
export var iconBubbleInner = "k_bn";
export var iconWrap = "k_bp";